import React from 'react';
import PropertyBase, { IBasePropertyProps } from './PropertyBase';
import { IconSelectionStyles } from '../../globals';
import Spacer from '../layout/Spacer';
import { IconFillStyles } from '../Iconset';

interface IIconSelectionOption
{
	display: React.ReactNode;
	value: any;
}

interface IIconSelectionPropertyProps extends IBasePropertyProps
{
	options: Array<IIconSelectionOption> | Array<Array<IIconSelectionOption>>;
	selectionStyle?: IconSelectionStyles;
	baseStyle?: React.CSSProperties;
}

export default function IconSelectionProperty(props: IIconSelectionPropertyProps)
{
	const dataName = (props["data-name"] ? props["data-name"] + "-" : "") + "-dropdown-property";

	function generateLine(options, lineIndex = 0)
	{
		const buttons = new Array<React.ReactNode>();
		for (const option of options)
		{
			buttons.push(
				<div
					key={option.value}
					className={"iconSelectionOption " + props.selectionStyle}
					data-name={"icon-selection-property-" + option.value}
					data-status={option.value === props.value && !props.multivalues ? "selected" : ""}
					onClick={(e) =>
					{
						if (props.onCommitCallback)
						{
							props.onCommitCallback(option.value);
						}
						else if (props.onChangeCallback)
						{
							props.onChangeCallback(option.value);
						}
					}}
				>
					{
						!React.isValidElement(option.display) ? option.display :
							React.cloneElement(option.display, {
								fillStyle: option.value === props.value && !props.multivalues && props.selectionStyle !== IconSelectionStyles.outline ? IconFillStyles.dark : IconFillStyles.default
							})
					}
				</div>
			);
			buttons.push(
				<Spacer key={option.value + '_spacer'} size={{ x: '6px' }} />
			);
		}
		return (
			<div className={"iconSelectionRowWrapper"} key={"line-" + lineIndex}>
				{buttons}
			</div>
		);
	}

	function generateButtons()
	{
		if (!Array.isArray(props.options[0]))
		{
			return generateLine(props.options);
		}

		const buttonLines = new Array<React.ReactNode>();
		for (let i = 0; i < props.options.length; i++)
		{
			buttonLines.push(generateLine(props.options[i], i));
			if (i < props.options.length - 1)
				buttonLines.push(<Spacer key={i + 'seperator_spacer'} size={{ y: '5px' }} />);
		}

		return (
			<div className={"iconSelectionIconsRoot"}>
				{buttonLines}
			</div>
		);
	}

	return (
		<PropertyBase {...props}
			data-name={dataName + "-root"}
			style={props.baseStyle}
		>
			{generateButtons()}
		</PropertyBase>
	);
}
